import { render, staticRenderFns } from "./transfersList.vue?vue&type=template&id=2673e384&scoped=true&"
import script from "./transfersList.vue?vue&type=script&lang=js&"
export * from "./transfersList.vue?vue&type=script&lang=js&"
import style0 from "./transfersList.vue?vue&type=style&index=0&id=2673e384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2673e384",
  null
  
)

export default component.exports